import { useState, useMemo, useEffect } from 'react';
import { CaretDownOutlined, CheckOutlined } from '@ant-design/icons';
import { Tree, message, Spin } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import API from '@api/api';
import Iconfont from '@utils/Iconfont';
import styles from './index.module.scss';

/**
 * ??????????????? Tree ???????
 */
const transformTreeData = (list) => {
    if (!Array.isArray(list)) return [];
    return list.map((item) => {
        const node = {
            key: item.id,
            title: item.name,
            depth: item.depth ?? 0,
            isLeaf: !item.children || item.children.length === 0,
        };
        if (item.children && item.children.length > 0) {
            node.children = transformTreeData(item.children);
        }
        return node;
    });
};

/**
 * ???/?????????
 * @param {boolean} open - ????
 * @param {'folder'|'res'|'share'} mode - ???folder=??????res=??????share=???????
 * @param {Array} menuList - ?????????folder/res?????
 * @param {string} currentFolderId - folder??????????ID
 * @param {string[]} resIds - res/share??????????ID??
 * @param {string} shareScope - share??????scope???enterprise
 * @param {function} onSuccess - ??????
 * @param {function} onCancel - ????
 */
const MoveFolderModal = ({
    open,
    mode = 'folder',
    menuList = [],
    currentFolderId,
    resIds = [],
    shareScope = 'enterprise',
    zIndex,
    getContainer,
    onSuccess,
    onCancel,
}) => {
    const [selectedKey, setSelectedKey] = useState(null);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [shareMenuList, setShareMenuList] = useState([]);
    const [shareTreeLoading, setShareTreeLoading] = useState(false);

    const effectiveMenuList = mode === 'share' ? shareMenuList : menuList;
    const treeData = useMemo(() => transformTreeData(effectiveMenuList), [effectiveMenuList]);

    useEffect(() => {
        if (!open || mode !== 'share') return;
        setShareTreeLoading(true);
        API.materialFolderTree({ scope: shareScope })
            .then((res) => {
                if (res?.code === 0 && Array.isArray(res.data)) {
                    setShareMenuList(res.data);
                } else {
                    setShareMenuList([]);
                }
            })
            .catch(() => {
                setShareMenuList([]);
            })
            .finally(() => {
                setShareTreeLoading(false);
            });
    }, [open, mode, shareScope]);

    const handleAfterOpenChange = () => {
        if (open) {
            setSelectedKey(null);
            setExpandedKeys([]);
        }
    };

    const handleSelect = (selectedKeys) => {
        if (selectedKeys.length > 0) {
            setSelectedKey(selectedKeys[0]);
        }
    };

    const handleNodeToggle = (nodeData, e) => {
        e.stopPropagation();
        const isExpanded = expandedKeys.includes(nodeData.key);
        const newKeys = isExpanded
            ? expandedKeys.filter(k => k !== nodeData.key)
            : [...expandedKeys, nodeData.key];
        setExpandedKeys(newKeys);
    };

    const titleRender = (nodeData) => {
        const isActive = selectedKey === nodeData.key;
        const isExpanded = expandedKeys.includes(nodeData.key);
        const hasChildren = nodeData.children && nodeData.children.length > 0;
        const icon = isActive || (hasChildren && isExpanded)
            ? <Iconfont type="icon-Material-FolderOpenOutlined" />
            : <Iconfont type="icon-Material-FolderOutlined" />;

        return (
            <div style={{ display: 'flex', width: '100%', overflow: 'hidden', minWidth: 0 }}>
                <div className={`${styles.moveNodeContent} ${isActive ? styles.activeNode : ''}`} style={{ flex: 1, minWidth: 0 }}>
                    {hasChildren ? (
                        <span
                            className={`${styles.customSwitcher} ${isExpanded ? styles.expanded : ''}`}
                            onClick={(e) => handleNodeToggle(nodeData, e)}
                        >
                            <CaretDownOutlined />
                        </span>
                    ) : (
                        <span className={styles.switcherPlaceholder} />
                    )}
                    <span className={styles.nodeIcon}>{icon}</span>
                    <span className={styles.nodeTitle}>{nodeData.title}</span>
                    {isActive && (
                        <span className={styles.checkIcon}><CheckOutlined /></span>
                    )}
                </div>
            </div>
        );
    };

    const modalTitle = mode === 'share' ? '分享到企业目录' : (mode === 'res' ? '参考图移动到' : '文件移动到');
    const okText = mode === 'share' ? '分享到此' : '移动到此';

    return (
        <PSAIModal
            title={modalTitle}
            open={open}
            onOk={() => {
                if (selectedKey === null) return;
                setLoading(true);
                const targetFolderId = selectedKey === 'refImage_all' ? '' : selectedKey;
                const apiCall = mode === 'res'
                    ? API.materialResMove({ resIds, targetFolderId })
                    : mode === 'share'
                        ? API.materialResShare({ resIds, targetFolderId })
                        : API.materialFolderMove({ folderId: currentFolderId, targetParentId: selectedKey });
                apiCall
                    .then((res) => {
                        if (res.code === 0) {
                            message.success(mode === 'share' ? '参考图已分享到企业' : '移动成功');
                            onSuccess?.();
                        } else {
                            message.error(res.message || (mode === 'share' ? '分享失败' : '移动失败'));
                        }
                    })
                    .catch(() => {
                        message.error(mode === 'share' ? '分享失败，请稍后重试' : '移动失败，请稍后重试');
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }}
            onCancel={onCancel}
            maxWidth={500}
            bodyStyle={{ height: 468 - 55 - 53, padding: 0 }}
            okText={okText}
            confirmLoading={loading}
            okButtonProps={{ disabled: !selectedKey || (mode === 'share' && shareTreeLoading) }}
            afterOpenChange={handleAfterOpenChange}
            getContainer={getContainer}
            {...(zIndex != null ? { zIndex } : {})}
        >
            <div className={`${styles.moveTreeWrap} _beauty_scrollbar`}>
                {(mode === 'res' || mode === 'share') && (
                    <div
                        className={`${styles.moveNodeContent} ${selectedKey === 'refImage_all' ? styles.activeNode : ''}`}
                        style={{ marginBottom: 8, cursor: 'pointer' }}
                        onClick={() => setSelectedKey('refImage_all')}
                    >
                        <span className={styles.switcherPlaceholder} />
                        <span className={styles.nodeIcon}>
                            {selectedKey === 'refImage_all'
                                ? <Iconfont type="icon-Material-FolderOpenOutlined" />
                                : <Iconfont type="icon-Material-FolderOutlined" />}
                        </span>
                        <span className={styles.nodeTitle}>全部参考图</span>
                        {selectedKey === 'refImage_all' && (
                            <span className={styles.checkIcon}><CheckOutlined /></span>
                        )}
                    </div>
                )}
                {mode === 'share' && shareTreeLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
                        <Spin size="small" />
                    </div>
                ) : (
                    <Tree
                        treeData={treeData}
                        expandedKeys={expandedKeys}
                        onExpand={(keys) => setExpandedKeys(keys)}
                        selectedKeys={selectedKey ? [selectedKey] : []}
                        onSelect={handleSelect}
                        titleRender={titleRender}
                        blockNode
                        showIcon={false}
                        switcherIcon={null}
                        className={styles.moveTree}
                    />
                )}
            </div>
        </PSAIModal>
    );
};

export default MoveFolderModal;
